import { css } from "@emotion/react";
import { Info } from "@material-ui/icons";
import styled, { ThemedCssCreator } from "../../../config/emotion";

export const tooltipHeaderCss: ThemedCssCreator = ({ colors }) => css`
  padding: 5px 10px;
  width: 100%;
  border-bottom: 1px solid ${colors.bgColor};
  font-weight: bold;
  font-size: 16px;
  margin: 0;
  color: ${colors.secondaryColor};
`;

export const tooltipParagraphCss: ThemedCssCreator = ({ colors }) => css`
  padding: 5px 10px;
  color: lightgray;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 0;
`;

export const TooltipIcon = styled(Info)`
  color: gray;
  cursor: pointer;

  &:hover {
    color: lightgray;
  }
`;
